import numeral from 'numeral';
import { FormattersTypes } from '@/services/types/formatter'
import { FORMATS } from '@/services/constants/format'
import compare_reports from '@/views/formatters/compare_reports';

export default ({ vtag, component, data, key, decimal = 0 }: FormattersTypes) => {

  component.tag = 'span';

  if(Array.isArray(data[key])){
    return compare_reports({
      beforeValue:'',
      vtag,
      data:[
        numeral(data[key][0] || 0).format(FORMATS[decimal]),
        numeral(data[key][1] || 0).format(FORMATS[decimal]),
        numeral(data[key][2] || 0).format(FORMATS[decimal]),
        numeral(data[key][3] || 0).format(FORMATS[decimal]),
      ],
    });
  }

  let val = numeral(data[key] || 0).format(FORMATS[decimal]);
  return vtag('div', {class: 'class-name'}, [val]);
}
